import { ProductSalesPaginationDTO, SalesPaginationDTO } from "../../dtos/batch";
import axios from "../../utils/axiosConfig";
axios.defaults.withCredentials = true;

const getSalesHistory = async (pharmacy_id: any, dto?: SalesPaginationDTO) => {
  let url = `/api/pharmacy/sales/get?pharmacy_id=${pharmacy_id}`;

  // If dto exists, add optional parameters
  if (dto) {
    if (dto.page) url += `&page=${encodeURIComponent(dto.page)}`;
    if (dto.limit) url += `&limit=${encodeURIComponent(dto.limit)}`;
    if (dto.start_date)
      url += `&start_date=${encodeURIComponent(dto.start_date)}`;
    if (dto.end_date) url += `&end_date=${encodeURIComponent(dto.end_date)}`;
    if (dto.id) url += `&id=${encodeURIComponent(dto.id)}`;
    if (dto.search) url += `&search=${encodeURIComponent(dto.search)}`
  }

  const { data } = await axios.get(url);
  return data;
};
const getProductSalesHistory = async (pharmacy_id: any, dto?: ProductSalesPaginationDTO) => {
  let url = `/api/pharmacy/sales/medicine_count?pharmacy_id=${pharmacy_id}`;

  // If dto exists, add optional parameters
  if (dto) {
    if (dto.page) url += `&page=${encodeURIComponent(dto.page)}`;
    if (dto.limit) url += `&limit=${encodeURIComponent(dto.limit)}`;
    if (dto.start_date)
      url += `&start_date=${encodeURIComponent(dto.start_date)}`;
    if (dto.end_date) url += `&end_date=${encodeURIComponent(dto.end_date)}`;
    if (dto.search) url += `&search=${encodeURIComponent(dto.search)}`
  }

  const { data } = await axios.get(url);
  return data;
};

const SalesHistoryService = {
  getSalesHistory,
  getProductSalesHistory,
};

export default SalesHistoryService;
